import React from 'react';
import { isMobile, isTablet } from 'react-device-detect';

const InfoVideo = ({ title, description, source }) => {
  const [isPlaying, setIsPlaying] = React.useState(false);
  const videoRef = React.useRef(null);

  const handlePlay = () => {
    videoRef.current.play();
    setIsPlaying(true);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        width: '100%',
        paddingBottom: '15px',
        gridColumnGap: '20px',
        position: 'relative',
      }}
    >
      {/* Video Area */}
      <div
        style={{
          flex: "4 1 6%",
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <video
          loading="lazy"
          poster={source.slice(0, -4) + '.png'}
          ref={videoRef}
          controls={isPlaying}
          style={{
            width: '100%',
            height: '100%',
            borderRadius: '10px',
            border: 'solid #5475e9 2px',
            objectFit: 'contain',
          }}
          playsInline
        >
          <source src={source} type="video/mp4" />
        </video>
        {!isPlaying && (
          <img
            src="https://www.latentculture.com/todem/playvideo.png"
            alt="Play Video"
            onClick={handlePlay}
            style={{
              position: 'absolute',
              maxWidth: '50%',
              maxHeight: '50%',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              cursor: 'pointer',
            }}
          />
        )}
      </div>

      {/* Text Area */}
      <div
        style={{
          flex: '4',
          padding: '20px',
          overflow: 'auto',
        }}
      >
        <h6>{title}</h6>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default InfoVideo;
